import { makeStyles, createStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      padding: `0 ${theme.spacing(2)}px`,
      minHeight: 280,
    },
    partipantsContainer: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: 60,

      '& > * + *': {
        marginLeft: theme.spacing(3.73),
      },
    },
    participantsWrapper: {
      display: 'flex',
      alignItems: 'center',

      '& > * + *': {
        marginLeft: theme.spacing(0.625),
      },
    },
    participantsCount: {
      fontSize: theme.typography.pxToRem(24),
      fontWeight: 'bold',
    },
    participantsInfo: {
      lineHeight: theme.typography.pxToRem(24),
    },
  }),
);
